// Elite Games — Rasca y Gana (popup)
// Canvas scratch + captura de correo. Sin dependencias externas.

(function () {
  'use strict';

  var STORAGE_KEY = 'eg_rg_state';
  var BRUSH_RADIUS = 20;      // px CSS — círculo, como la yema del dedo
  var CHECK_EVERY = 6;        // se mide el % de raspado cada N movimientos
  var SAMPLE_STEP = 8;        // se muestrea 1 de cada 8 píxeles (rendimiento)

  /* ─── Estado persistido ─────────────────────────────────── */

  function readState() {
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || null;
    } catch (e) {
      return null;
    }
  }

  function writeState(patch) {
    try {
      var next = readState() || {};
      for (var k in patch) if (Object.prototype.hasOwnProperty.call(patch, k)) next[k] = patch[k];
      next.ts = Date.now();
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch (e) {
      /* modo incógnito o storage lleno: el popup simplemente vuelve a salir */
    }
  }

  function expired(state, days) {
    if (!state || !state.ts) return true;
    return Date.now() - state.ts > days * 24 * 60 * 60 * 1000;
  }

  /* ─── Utilidades ────────────────────────────────────────── */

  // ?rasca=1 → modo prueba: sale siempre, ignora localStorage y no guarda nada
  function forceMode() {
    try {
      return /[?&]rasca=1(&|$)/.test(window.location.search);
    } catch (e) {
      return false;
    }
  }

  // ?paso=email → saltar directo a esa pantalla (útil para revisar en el móvil)
  function forcedStep() {
    try {
      var m = /[?&]paso=(scratch|claim|email|code)(&|$)/.exec(window.location.search);
      return m ? m[1] : '';
    } catch (e) {
      return '';
    }
  }

  function isDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  // Dio el correo pero se quedó sin código: hay que devolvérselo al volver
  function pendingCode() {
    var st = readState() || {};
    return !!st.email && !st.done;
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value.trim());
  }

  // Contador "quedan N premios" estable durante todo el día
  function dailyStock(min, max) {
    var d = new Date();
    var seed = d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
    var span = Math.max(1, max - min + 1);
    return min + ((seed * 9301 + 49297) % 233280) % span;
  }

  function drawSpacedText(ctx, text, cx, cy, spacing) {
    var chars = text.split('');
    var widths = [];
    var total = 0;
    var i;
    for (i = 0; i < chars.length; i++) {
      widths[i] = ctx.measureText(chars[i]).width;
      total += widths[i] + spacing;
    }
    total -= spacing;
    var x = cx - total / 2;
    for (i = 0; i < chars.length; i++) {
      ctx.fillText(chars[i], x + widths[i] / 2, cy);
      x += widths[i] + spacing;
    }
  }

  /* ─── Capa metálica morada ──────────────────────────────── */

  // Dibuja una imagen cubriendo todo el canvas (object-fit: cover)
  function drawCover(ctx, img, w, h) {
    var scale = Math.max(w / img.naturalWidth, h / img.naturalHeight);
    var dw = img.naturalWidth * scale;
    var dh = img.naturalHeight * scale;
    ctx.drawImage(img, (w - dw) / 2, (h - dh) / 2, dw, dh);
  }

  function paintScratchLayer(ctx, w, h, label, img) {
    ctx.globalCompositeOperation = 'source-over';
    ctx.clearRect(0, 0, w, h);

    // Si hay imagen cargada desde el theme editor, esa es la capa que se raspa
    if (img && img.complete && img.naturalWidth) {
      drawCover(ctx, img, w, h);
      return;
    }

    // Base metálica: bandas alternadas oscuro/claro sobre el morado de marca
    var metal = ctx.createLinearGradient(0, 0, w, h);
    metal.addColorStop(0.00, '#2a1a4d');
    metal.addColorStop(0.14, '#5b21b6');
    metal.addColorStop(0.28, '#a78bfa');
    metal.addColorStop(0.38, '#ede4ff');
    metal.addColorStop(0.48, '#8a2eff');
    metal.addColorStop(0.62, '#3b1d73');
    metal.addColorStop(0.74, '#b87cff');
    metal.addColorStop(0.86, '#4c1d95');
    metal.addColorStop(1.00, '#241542');
    ctx.fillStyle = metal;
    ctx.fillRect(0, 0, w, h);

    // Brillo diagonal (reflejo)
    var sheen = ctx.createLinearGradient(0, h, w, 0);
    sheen.addColorStop(0.00, 'rgba(255,255,255,0)');
    sheen.addColorStop(0.42, 'rgba(255,255,255,.28)');
    sheen.addColorStop(0.52, 'rgba(255,255,255,.05)');
    sheen.addColorStop(1.00, 'rgba(255,255,255,0)');
    ctx.fillStyle = sheen;
    ctx.fillRect(0, 0, w, h);

    // Cepillado fino (brushed metal)
    ctx.save();
    ctx.lineWidth = 1;
    for (var x = -h; x < w; x += 3) {
      ctx.strokeStyle = (x % 6 === 0) ? 'rgba(255,255,255,.05)' : 'rgba(0,0,0,.06)';
      ctx.beginPath();
      ctx.moveTo(x, h);
      ctx.lineTo(x + h, 0);
      ctx.stroke();
    }
    ctx.restore();

    // Viñeta en los bordes para dar profundidad
    var vign = ctx.createRadialGradient(w / 2, h / 2, Math.min(w, h) * 0.25, w / 2, h / 2, Math.max(w, h) * 0.75);
    vign.addColorStop(0, 'rgba(0,0,0,0)');
    vign.addColorStop(1, 'rgba(0,0,0,.35)');
    ctx.fillStyle = vign;
    ctx.fillRect(0, 0, w, h);

    // Texto "RASPA AQUÍ"
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.font = '700 ' + Math.round(Math.min(w, h) * 0.105) + 'px "Rajdhani", "Inter", system-ui, sans-serif';
    ctx.fillStyle = 'rgba(10,4,26,.30)';
    drawSpacedText(ctx, label, w / 2 + 1, h / 2 + 1, 4);
    ctx.fillStyle = 'rgba(255,255,255,.42)';
    drawSpacedText(ctx, label, w / 2, h / 2, 4);
  }

  /* ─── Instancia del popup ───────────────────────────────── */

  function ScratchPopup(root) {
    this.root = root;
    this.modal = root.querySelector('[data-rg-modal]');
    this.card = root.querySelector('[data-rg-card]');
    this.canvas = root.querySelector('[data-rg-canvas]');
    this.hint = root.querySelector('[data-rg-hint]');
    this.roulette = root.querySelector('[data-rg-roulette]');
    this.stepClaim = root.querySelector('[data-rg-step="claim"]');
    this.stepEmail = root.querySelector('[data-rg-step="email"]');
    this.stepCode = root.querySelector('[data-rg-step="code"]');
    this.form = root.querySelector('.eg-rg__form');
    this.input = root.querySelector('[data-rg-email]');
    this.error = root.querySelector('[data-rg-error]');
    this.submit = root.querySelector('[data-rg-submit]');
    this.copyBtn = root.querySelector('[data-rg-copy]');

    this.opts = {
      delay: parseInt(root.dataset.delay, 10) || 0,
      days: parseInt(root.dataset.days, 10) || 30,
      threshold: parseInt(root.dataset.threshold, 10) || 55,
      cartCount: parseInt(root.dataset.cartCount, 10) || 0,
      hideWithCart: root.dataset.hideWithCart === 'true',
      scratchLabel: root.dataset.scratchLabel || 'RASPA AQUÍ',
      scratchSrc: root.dataset.scratchSrc || '',
      previewStep: root.dataset.previewStep || 'auto',
      copyLabel: this.copyBtn ? this.copyBtn.textContent.trim() : '',
      copiedLabel: root.dataset.copiedLabel || '¡Copiado!',
      code: root.dataset.code || '',
      decoys: (root.dataset.decoys || '').split('\n').map(function (s) { return s.trim(); }).filter(Boolean)
    };

    this.force = forceMode() || !!forcedStep();
    this.isOpen = false;
    this.isDrawing = false;
    this.revealed = false;
    this.moves = 0;
    this.lastPoint = null;
    this.lastFocus = null;

    this.bind();
  }

  ScratchPopup.prototype.bind = function () {
    var self = this;

    this.root.querySelectorAll('[data-rg-close]').forEach(function (el) {
      el.addEventListener('click', function () { self.close(); });
    });

    this.onKeydown = function (e) {
      if (!self.isOpen) return;
      if (e.key === 'Escape') { self.close(); return; }
      if (e.key === 'Tab') self.trapFocus(e);
    };
    document.addEventListener('keydown', this.onKeydown);

    // Rascado — mouse
    this.canvas.addEventListener('mousedown', function (e) { self.start(e); });
    window.addEventListener('mousemove', function (e) { self.move(e); });
    window.addEventListener('mouseup', function () { self.end(); });

    // Rascado — touch
    this.canvas.addEventListener('touchstart', function (e) { self.start(e); }, { passive: false });
    this.canvas.addEventListener('touchmove', function (e) { self.move(e); }, { passive: false });
    this.canvas.addEventListener('touchend', function () { self.end(); });
    this.canvas.addEventListener('touchcancel', function () { self.end(); });

    if (this.form) {
      this.form.addEventListener('submit', function (e) { self.onSubmit(e); });
    }
    if (this.copyBtn) {
      this.copyBtn.addEventListener('click', function () { self.copyCode(); });
    }
    var claimBtn = this.root.querySelector('[data-rg-claim]');
    if (claimBtn) {
      claimBtn.addEventListener('click', function () { self.showEmailStep(); });
    }

    window.addEventListener('resize', function () {
      if (self.isOpen && !self.revealed) self.setupCanvas();
    });
  };

  /* ─── Apertura / cierre ─────────────────────────────────── */

  ScratchPopup.prototype.shouldShow = function () {
    if (this.force) return true;
    if (this.opts.hideWithCart && this.opts.cartCount > 0) return false;
    var state = readState();
    if (state && (state.seen || state.done) && !expired(state, this.opts.days)) return false;
    return true;
  };

  ScratchPopup.prototype.schedule = function () {
    var self = this;
    if (!this.shouldShow()) return;
    var wait = this.force ? 300 : this.opts.delay * 1000;
    window.setTimeout(function () { self.open(self.force); }, wait);
  };

  ScratchPopup.prototype.open = function (skipPersist) {
    if (this.isOpen) return;
    this.isOpen = true;
    this.lastFocus = document.activeElement;

    this.root.classList.add('is-open');
    document.documentElement.classList.add('eg-rg-lock');
    document.body.classList.add('eg-rg-lock');

    var self = this;
    window.requestAnimationFrame(function () {
      self.root.classList.add('is-visible');
      self.setupCanvas();
      // La URL manda sobre el ajuste del editor
      // previewStep es solo para diseñar: en la tienda el recorrido es siempre real
      var pinned = isDesignMode() ? self.opts.previewStep : '';
      self.showStep(forcedStep() || self.pendingStep || pinned);
      var close = self.root.querySelector('[data-rg-close]');
      if (close) close.focus();
    });

    this.bindViewport();
    this.startRoulette();
    if (!skipPersist) writeState({ seen: true });
  };

  ScratchPopup.prototype.close = function () {
    if (!this.isOpen) return;
    // Cerrar estando en la pantalla del código cuenta como recibido
    if (!this.force && this.root.classList.contains('is-done')) writeState({ done: true });
    this.isOpen = false;
    this.stopRoulette();
    this.unbindViewport();
    this.root.classList.remove('is-visible');

    var self = this;
    window.setTimeout(function () {
      self.root.classList.remove('is-open');
      document.documentElement.classList.remove('eg-rg-lock');
      document.body.classList.remove('eg-rg-lock');
      if (self.lastFocus && self.lastFocus.focus) self.lastFocus.focus();
    }, 320);
  };

  // Deja el popup plantado en una pantalla, sin tener que raspar ni enviar el correo
  ScratchPopup.prototype.showStep = function (step) {
    if (!step || step === 'auto' || step === 'scratch') return;

    this.revealed = true;
    this.card.classList.add('is-revealed');
    if (this.hint) this.hint.classList.add('is-hidden');
    if (this.stepClaim) this.stepClaim.classList.remove('is-active');
    if (this.stepEmail) this.stepEmail.classList.remove('is-active');
    if (this.stepCode) this.stepCode.classList.remove('is-active');
    this.root.classList.remove('is-compact', 'is-done');

    if (step === 'claim' && this.stepClaim) {
      this.stepClaim.classList.add('is-active');
    } else if (step === 'email' && this.stepEmail) {
      this.root.classList.add('is-compact');
      this.stepEmail.classList.add('is-active');
    } else if (step === 'code' && this.stepCode) {
      this.root.classList.add('is-done');
      this.stepCode.classList.add('is-active');
    }
  };

  ScratchPopup.prototype.destroy = function () {
    this.stopRoulette();
    this.unbindViewport();
    if (this.onKeydown) document.removeEventListener('keydown', this.onKeydown);
    document.documentElement.classList.remove('eg-rg-lock');
    document.body.classList.remove('eg-rg-lock');
    this.isOpen = false;
  };

  ScratchPopup.prototype.trapFocus = function (e) {
    var focusables = this.modal.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"])');
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  };

  /* ─── Ruleta de premios (solo visual) ───────────────────── */

  ScratchPopup.prototype.startRoulette = function () {
    if (!this.roulette || this.opts.decoys.length < 2) return;
    var self = this;
    var i = 0;
    this.rouletteTimer = window.setInterval(function () {
      i = (i + 1) % self.opts.decoys.length;
      self.roulette.textContent = self.opts.decoys[i];
      self.roulette.classList.remove('is-swap');
      void self.roulette.offsetWidth;
      self.roulette.classList.add('is-swap');
    }, 900);
  };

  ScratchPopup.prototype.stopRoulette = function () {
    if (this.rouletteTimer) {
      window.clearInterval(this.rouletteTimer);
      this.rouletteTimer = null;
    }
  };

  /* ─── Canvas ────────────────────────────────────────────── */

  ScratchPopup.prototype.setupCanvas = function () {
    var rect = this.card.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    this.canvas.width = Math.round(rect.width * dpr);
    this.canvas.height = Math.round(rect.height * dpr);

    this.ctx = this.canvas.getContext('2d', { willReadFrequently: true });
    this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    var self = this;
    var repaint = function () {
      paintScratchLayer(self.ctx, rect.width, rect.height, self.opts.scratchLabel, self.layerImg);
    };
    repaint();

    // Capa rascable desde el theme editor
    if (this.opts.scratchSrc && !this.layerImg) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        self.layerImg = img;
        if (!self.revealed && !self.moves) repaint();
      };
      img.src = this.opts.scratchSrc;
    }

    // Si el fallback dibuja texto, repintar cuando carguen las fuentes
    if (!this.opts.scratchSrc && document.fonts && document.fonts.ready && !this.fontsDone) {
      document.fonts.ready.then(function () {
        self.fontsDone = true;
        if (!self.revealed && !self.moves) repaint();
      });
    }
  };

  ScratchPopup.prototype.pointFrom = function (e) {
    var rect = this.canvas.getBoundingClientRect();
    var src = e.touches && e.touches.length ? e.touches[0] : e;
    return { x: src.clientX - rect.left, y: src.clientY - rect.top };
  };

  ScratchPopup.prototype.start = function (e) {
    if (this.revealed) return;
    e.preventDefault();
    this.stopRoulette();
    if (this.roulette) this.roulette.textContent = '???';
    if (this.hint) this.hint.classList.add('is-hidden');

    this.isDrawing = true;
    this.lastPoint = this.pointFrom(e);
    this.scratchAt(this.lastPoint);
  };

  ScratchPopup.prototype.move = function (e) {
    if (!this.isDrawing || this.revealed) return;
    e.preventDefault();
    var point = this.pointFrom(e);
    this.scratchAt(point, this.lastPoint);
    this.lastPoint = point;

    this.moves++;
    if (this.moves % CHECK_EVERY === 0 && this.cleared() >= this.opts.threshold) this.reveal();
  };

  ScratchPopup.prototype.end = function () {
    if (!this.isDrawing) return;
    this.isDrawing = false;
    this.lastPoint = null;
    if (!this.revealed && this.cleared() >= this.opts.threshold) this.reveal();
  };

  ScratchPopup.prototype.scratchAt = function (point, from) {
    var ctx = this.ctx;
    if (!ctx) return;
    ctx.globalCompositeOperation = 'destination-out';

    if (from) {
      ctx.lineWidth = BRUSH_RADIUS * 2;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.beginPath();
      ctx.moveTo(from.x, from.y);
      ctx.lineTo(point.x, point.y);
      ctx.stroke();
    }

    ctx.beginPath();
    ctx.arc(point.x, point.y, BRUSH_RADIUS, 0, Math.PI * 2, false);
    ctx.fill();
  };

  // % de píxeles ya transparentes
  ScratchPopup.prototype.cleared = function () {
    if (!this.ctx) return 0;
    var w = this.canvas.width;
    var h = this.canvas.height;
    if (!w || !h) return 0;

    var data = this.ctx.getImageData(0, 0, w, h).data;
    var transparent = 0;
    var total = 0;
    for (var i = 3; i < data.length; i += 4 * SAMPLE_STEP) {
      total++;
      if (data[i] < 40) transparent++;
    }
    return total ? (transparent / total) * 100 : 0;
  };

  ScratchPopup.prototype.reveal = function () {
    if (this.revealed) return;
    this.revealed = true;
    this.isDrawing = false;
    this.card.classList.add('is-revealed');
    if (this.hint) this.hint.classList.add('is-hidden');
    if (!this.force) writeState({ seen: true, scratched: true });

    var self = this;
    window.setTimeout(function () {
      // Tras raspar aparece el CTA; el correo se pide al reclamar la oferta
      if (self.stepClaim) self.stepClaim.classList.add('is-active');
      else if (self.stepEmail) self.stepEmail.classList.add('is-active');
    }, 620);
  };

  ScratchPopup.prototype.showEmailStep = function () {
    if (this.stepClaim) this.stepClaim.classList.remove('is-active');
    if (!this.stepEmail) return;

    // El premio sube y todo se compacta antes de que entre el teclado
    this.root.classList.add('is-compact');
    this.stepEmail.classList.add('is-active');

    // focus() síncrono: iOS solo abre el teclado dentro del gesto del usuario
    if (this.input) this.input.focus();

    var self = this;
    window.setTimeout(function () {
      if (self.input && self.input.scrollIntoView) {
        self.input.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }, 340);
  };

  // El teclado móvil reduce el visualViewport; ajustamos el alto real del modal
  ScratchPopup.prototype.bindViewport = function () {
    var vv = window.visualViewport;
    if (!vv || this.onViewport) return;
    var self = this;
    this.onViewport = function () {
      self.root.style.setProperty('--rg-vh', Math.round(vv.height) + 'px');
    };
    vv.addEventListener('resize', this.onViewport);
    vv.addEventListener('scroll', this.onViewport);
    this.onViewport();
  };

  ScratchPopup.prototype.unbindViewport = function () {
    var vv = window.visualViewport;
    if (!vv || !this.onViewport) return;
    vv.removeEventListener('resize', this.onViewport);
    vv.removeEventListener('scroll', this.onViewport);
    this.onViewport = null;
    this.root.style.removeProperty('--rg-vh');
  };

  /* ─── Alta del correo ───────────────────────────────────── */

  ScratchPopup.prototype.onSubmit = function (e) {
    e.preventDefault();
    if (!this.input) return;

    var email = this.input.value.trim();
    if (!isValidEmail(email)) {
      this.input.setAttribute('aria-invalid', 'true');
      if (this.error) this.error.classList.add('is-active');
      this.input.focus();
      return;
    }
    this.input.removeAttribute('aria-invalid');
    if (this.error) this.error.classList.remove('is-active');

    // Se guarda antes de enviar: si el captcha de Shopify fuerza una recarga,
    // al volver sabemos que había raspado y le mostramos el código igual.
    if (!this.force) writeState({ seen: true, scratched: true, email: email });

    // El código se entrega al instante. El alta en Shopify va en segundo plano:
    // nunca debe quitarle el premio al cliente ni sacarlo de la página, pase lo
    // que pase con la red o con la verificación anti-bot de Shopify.
    this.unlockCode(email);

    window.fetch(this.form.getAttribute('action') || '/contact', {
      method: 'POST',
      body: new FormData(this.form),
      headers: { Accept: 'text/html' },
      credentials: 'same-origin'
    }).catch(function () { /* el cliente ya tiene su código */ });
  };

  ScratchPopup.prototype.unlockCode = function (email) {
    // Ojo: NO se marca done todavía. Hasta que el cliente copie el código o
    // cierre a propósito, si vuelve se lo mostramos otra vez.
    if (!this.force) writeState({ seen: true, scratched: true, email: email });
    this.root.classList.remove('is-compact');
    this.root.classList.add('is-done');
    if (this.stepEmail) this.stepEmail.classList.remove('is-active');
    if (this.stepCode) this.stepCode.classList.add('is-active');
  };

  /* ─── Copiar código ─────────────────────────────────────── */

  ScratchPopup.prototype.copyCode = function () {
    var self = this;
    var code = this.opts.code;
    var done = function () {
      // Ya tiene el código en el portapapeles: recién ahora se cierra el ciclo
      if (!self.force) writeState({ done: true });
      self.copyBtn.textContent = self.opts.copiedLabel;
      window.setTimeout(function () { self.copyBtn.textContent = self.opts.copyLabel; }, 2000);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(function () { self.copyFallback(code, done); });
    } else {
      this.copyFallback(code, done);
    }
  };

  ScratchPopup.prototype.copyFallback = function (code, done) {
    var tmp = document.createElement('textarea');
    tmp.value = code;
    tmp.setAttribute('readonly', '');
    tmp.style.position = 'fixed';
    tmp.style.opacity = '0';
    document.body.appendChild(tmp);
    tmp.select();
    try { document.execCommand('copy'); done(); } catch (e) { /* noop */ }
    document.body.removeChild(tmp);
  };

  /* ─── Arranque ──────────────────────────────────────────── */

  var instances = {};

  function sectionIdOf(el) {
    var wrap = el.closest ? el.closest('[id^="shopify-section-"]') : null;
    return wrap ? wrap.id.replace('shopify-section-', '') : '';
  }

  // Quita la copia que ya estaba colgada del <body> (recarga de sección en el editor)
  function removePortaled(sid) {
    if (!sid) return;
    var old = document.querySelector('body > [data-eg-rg][data-section-id="' + sid + '"]');
    if (old) {
      if (old.egRasca) old.egRasca.destroy();
      if (old.parentNode) old.parentNode.removeChild(old);
    }
    delete instances[sid];
  }

  function init() {
    document.querySelectorAll('[data-eg-rg]').forEach(function (root) {
      if (root.egRasca) return;

      // El modal es position:fixed. Si queda dentro de un ancestro con transform
      // — el editor de temas se los aplica a las secciones — el fixed se rompe y
      // el popup se recorta a la altura de la sección. Colgarlo del <body> lo evita.
      var sid = root.dataset.sectionId || sectionIdOf(root);
      if (sid) {
        removePortaled(sid);
        root.setAttribute('data-section-id', sid);
      }
      if (root.parentNode !== document.body) document.body.appendChild(root);

      var popup = new ScratchPopup(root);
      root.egRasca = popup;
      if (sid) instances[sid] = popup;

      // Contador "quedan N premios hoy"
      var stock = root.querySelector('[data-rg-stock-value]');
      if (stock) {
        stock.textContent = dailyStock(
          parseInt(root.dataset.stockMin, 10) || 3,
          parseInt(root.dataset.stockMax, 10) || 12
        );
      }

      if (window.Shopify && window.Shopify.designMode) {
        // En el editor no se guarda nada en localStorage: siempre se puede probar.
        // Si hay una pantalla fijada, se abre solo para poder verla.
        var pinned = popup.opts.previewStep && popup.opts.previewStep !== 'auto';
        if (pinned || root.dataset.editorPreview === 'true') popup.open(true);
      } else if (pendingCode()) {
        // Dejó su correo pero nunca llegó a copiar el código: lo interrumpió el
        // captcha de Shopify, una recarga o un cierre. Se lo devolvemos.
        popup.pendingStep = 'code';
        popup.open(true);
      } else {
        popup.schedule();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor: abrir al seleccionar la sección, cerrar al salir.
  // Se busca por sectionId porque el popup ya no vive dentro de su wrapper.
  document.addEventListener('shopify:section:select', function (e) {
    var p = instances[e.detail && e.detail.sectionId];
    if (p) p.open(true);
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var p = instances[e.detail && e.detail.sectionId];
    if (p) p.close();
  });
  document.addEventListener('shopify:section:load', function (e) {
    if (e.detail && e.detail.sectionId) removePortaled(e.detail.sectionId);
    init();
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.detail && e.detail.sectionId) removePortaled(e.detail.sectionId);
  });
})();
